<template>
  <section class="website-section content-wrapper" v-if="isLoaded">
    <app-header></app-header>
    <div class="c-introduction">
      <header class="main-section-title">
        <h1>{{ $store.getters.settings.client.download_page_title }}</h1>
      </header>
      <div class="body-text-wrapper">
        <div class="body-text body-text--large" v-html="$store.getters.settings.client.download_page_body"></div>
      </div>
    </div>
    <div class="section-block download-wrapper">
      <ul class="download-list">
        <li class="download-list__item" v-for="folder in folders" v-if="folder.total_files > 0">
          <div class="download-item-title">
            <h4>{{ folder.name }}</h4>
            <div class="file-details">
              <span>{{ folder.total_files }} Files</span>
              <span>{{ folder.total_size }}</span>
            </div>
          </div>
          <div class="download-actions">
            <router-link class="t-text-color" v-if="folder.guideline_path" :to="{path:folder.guideline_path}">View
              guideline<span class="view-btn"></span></router-link>


            <a v-if="folder.zip_file" @click.prevent="download(folder,folder.name)" class="t-text-color download-actions__downlaod" href="#">
              Download
              <div v-if="loading === folder.id" class="loader"></div>
              <span v-else class="download-btn"></span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import appHeader from '../layout/Header.vue'

export default {
  components: {
    appHeader
  },
  data() {
    return {
      isLoaded: false,
      folders: {},
      loading: false
    }
  },
  methods: {
    getData() {
      this.$store.dispatch('setIsLoaded', false)
      this.isLoaded = false
      this.axios.get('/downloads')
        .then(response => {
          this.folders = response.data.folders
          this.$store.dispatch('setIsLoaded', true)
          this.isLoaded = true
          document.title = 'Download Center ' + ' - ' + this.$store.getters.settings.appName
        })
        .catch(error => {
          console.log(error)
        })
    },
    download(folder, Name) {
      if (this.loading === false) {
        // var windowRef = window.open()
        this.loading = folder.id
        this.axios.get('/downloads/download?id=' + folder.id, {}).then((response) => {
          if (response.data.url) {
            this.runDownload(response.data.url, Name)
            //     windowRef.location = response.data.url
            //     setTimeout(function () {
            //       windowRef.close()
            //     }, 500)
          }
        })
      }
    },
    async runDownload(url, Name) {
      await this.axios.get(url, {responseType: 'blob'}).then((response) => {
        const blob = new Blob([response.data], {type: 'application/zip'})
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = Name
        link.click()
        URL.revokeObjectURL(link.href)
        this.loading = false
      }).then(() => {
        this.loading = false
      })
    }
  },
  created() {
    this.getData()
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Downloads.vue